if (!customElements.get('variant-label')) {
  class VariantLabel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Børn (.js-variant-label) er først i DOM her – ikke i constructor
      const variantPicker = this.closest('.product-info')?.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }
      if (this.dataset.currentVariantId) {
        this.setVisibleVariantLabel(this.dataset.currentVariantId);
      }
    }

    setVisibleVariantLabel(variantId, attempt = 0) {
      const labels = this.querySelectorAll('.js-variant-label');
      const idStr = String(variantId ?? '').trim();
      let hasMatch = false;
      labels.forEach((label) => {
        const isActive = String(label.dataset.variantId ?? '').trim() === idStr;
        if (isActive) hasMatch = true;
        label.classList.toggle('hidden', !isActive);
      });
      // Ingen match kan ske pga. timing/DOM, så vi retry'er én gang i næste frame
      if (!hasMatch && attempt < 1) {
        requestAnimationFrame(() => this.setVisibleVariantLabel(variantId, attempt + 1));
      }
    }

    handleVariantChange(evt) {
      if (evt.detail?.variant?.id != null) {
        this.setVisibleVariantLabel(evt.detail.variant.id);
      }
    }
  }

  customElements.define('variant-label', VariantLabel);
}
